<template>
  <div class="check-box-addon-field">
    <p>
      <label>
        <input type="checkbox" v-model="fieldValue" :disabled="fieldDisable" />
        <span>{{ dataText }}</span>
      </label>
    </p>
  </div>
</template>
<script>
export default {
  name: "AddonCheckBoxField",
  props: {
    dataValue: {
      type: [String, Number, Boolean],
      default: () => "",
    },
    dataText: {
      type: String,
      default: "",
    },
    dataParentValue: {
      type: [String, Boolean],
      default: "",
    },
  },
  data() {
    return {
      fieldValue: this.dataValue,
      fieldDisable: false,
    };
  },
  watch: {
    fieldValue(val) {
    this.$emit("updateValue", val);
    },
    dataParentValue(nV) {
      if (this.fieldValue && nV) this.fieldValue = false;
      this.fieldDisable = !!this.dataParentValue;
    },
  },

  mounted() {
    this.fieldDisable = !!this.dataParentValue;
  },
  computed: {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.option-selector {
  border-radius: 10px;
  h5 {
    text-align: center;
  }
  .img-wrapper {
    height: 60px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }
  .img-wrapper-survey {
    display: flex;
    justify-content: center;
    img {
      margin: 0 auto;
      width: auto;
      height: 100%;
    }
  }

  @media only screen and (max-width: 600px) {
    max-width: 90% !important;
    width: 90%;
  }
}
</style>
